import React, { useState } from 'react';
import ShareModal from './ShareModal';
import { useAuth } from '../contexts/AuthContext';

const ShareButton = ({ card, onShare }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const { currentUser } = useAuth();

  const createShareText = () => {
    if (!card) {
      console.error('No card data provided to ShareButton');
      return '';
    }

    const text = [
      `Contact: ${card.name}`,
      card.role && `Role: ${card.role}`,
      card.company && `Company: ${card.company}`,
      card.linkedIn && `LinkedIn: ${card.linkedIn}`,
      card.spouse && `Spouse: ${card.spouse}`,
      card.children && `Children: ${card.children}`,
      card.parents && `Parents: ${card.parents}`,
      card.info && `\nNotes: ${card.info}`
    ].filter(Boolean).join('\n');

    return text;
  };

  const handleShare = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowShareModal(true);
  };

  return (
    <div className="relative">
      <button
        onClick={handleShare}
        className="p-3 flex items-center justify-center text-gray-600 hover:text-[#04b53a] hover:bg-gray-50 transition-colors w-full border-r"
        aria-label="Share contact"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
          <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
        </svg>
        <span className="font-medium">Share card</span>
      </button>

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        onShare={onShare}
        item={card}
        currentUser={currentUser}
        type="card"
      />
    </div>
  );
};

export default ShareButton;